import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";
import { useTranslation } from "react-i18next";
import * as Helpers from "../../../../global/Helpers";
import i18next from "i18next";
import * as Constants from "../../../../constants/Constants";
import * as utils from "../../../../global/utils";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../../SessionExpiredPOPup/SessionExpiredPOPup";
import { Redirect } from "react-router-dom";

const FatcaCRSDeclaration6 = (props) => {
  const { t } = useTranslation();

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="form-group">
            <h5>{t("are_you_an_insider")} </h5>
            <div className="seekbar-wrapper">
              <Insider saveKycDataAPI={props.saveKycDataAPI} setIsCallAPI={props.setIsCallAPI} IsCallAPI={props.IsCallAPI} handleNext={props.handleNext} />
            </div>
          </div>
          {/* <button type="submit" className="submit-button">Submit</button> */}
        </form>
      </div>
    </div>
  );
};

const Insider = (props) => {
  const { t } = useTranslation();
  const [CompaniesKYC, setCompaniesKYC] = useState([]);
  const [redirect, setRedirect] = useState(null);

  const [formState, setFormState] = useState({
    dropdown1: "",
    dropdown2: "",
    dropdown3: "",
  });

  const [oneValue, setoneValue] = useState(false);
  const handleSwitchChange1 = (event) => {
    setoneValue(event.target.checked);
  };

  const [TwoValue, setTwoValue] = useState(false);
  const handleSwitchChange2 = (event) => {
    setTwoValue(event.target.checked);
  };

  const [ThreeValue, setThreeValue] = useState(false);
  const handleSwitchChange3 = (event) => {
    setThreeValue(event.target.checked);
  };

  const [FoureValue, setFoureValue] = useState(false);
  const handleSwitchChange4 = (event) => {
    setFoureValue(event.target.checked);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };
  useEffect(() => {
    fetchGetCompaniesKYC();
  }, [i18next.language]);

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (oneValue && formState.dropdown1 === "") {
      Helpers.errorNotify(t("Please select company"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (TwoValue && formState.dropdown2 === "") {
      Helpers.errorNotify(t("Please select company"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (ThreeValue && formState.dropdown3 === "") {
      Helpers.errorNotify(t("Please select company"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }

    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;
    var Items = [
      // { ID: "144", Value: formState.dropdown1 },
      // { ID: "146", Value: formState.dropdown2 },
      // { ID: "145", Value: formState.dropdown3 }
    ];


    var result = Helpers.getScreenIdByGroupAndName("insider");
    
    var one = oneValue ? { ID: "144", Value: formState.dropdown1 } : null;
    var Two = TwoValue ? { ID: "146", Value: formState.dropdown2 } : null;
    var Three = ThreeValue ? { ID: "145", Value: formState.dropdown3 } : null;

    if (one !== null) Items.push(one);
    if (Two !== null) Items.push(Two);
    if (Three !== null) Items.push(Three);


    Items.push({ID: "288", Value: result?.GROUP_ID || "" });
    Items.push({ ID: "287", Value: result?.SCREEN_ID || "" });
    
    if (!oneValue && !TwoValue && !ThreeValue) {
      props.setIsCallAPI(false);
      props.handleNext();
    } else {
      Items.push({ ID: "258", Value: "1" });
      props.saveKycDataAPI(Items);
    }
  };
  const fetchGetCompaniesKYC = async () => {
    try {
      const data = { FormType: "1", Lang: i18next.language === "ar" ? "AR" : "EN" };
      var response = utils.CallKYCAPI(Constants.GetCompaniesKYC, data);
      await response
        .then((response) => {
          if (response.data.ErrorMsg === "success") {
            setCompaniesKYC(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return <SessionExpiredPOPup setRedirect={setRedirect} onClose={onClose} />;
              },
            });
          } else {
            setCompaniesKYC([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("GetCompaniesKYC", error);
        });
    } catch (error) {
      console.error("Error posting data GetCompaniesKYC:", error);
    }
  };
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <div className="FatcaCRSDeclaration Insider-div">
      <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
        <label htmlFor="dropdown5" className="form-label">
          {t("board_member_uae")}
        </label>
        <div className="switch-container">
          <label className="switch">
            <input type="checkbox" checked={oneValue} onChange={handleSwitchChange1} />
            <span className="slider"></span>
          </label>
          {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
        </div>
      </div>
      {oneValue ? (
        <select id="dropdown1" name="dropdown1" value={formState.dropdown1} onChange={handleChange} className="form-select">
          <option value="" disabled>
            {t("PleaseSelect")}
          </option>

          {CompaniesKYC.map((obj) => {
            return <option value={obj.value}>{obj.CompName}</option>;
          })}
        </select>
      ) : null}
      <hr style={{ width: "100%" }} />
      <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
        <label htmlFor="dropdown5" className="form-label">
          {t("hold_5_percent_or_more")}
        </label>
        <div className="switch-container">
          <label className="switch">
            <input type="checkbox" checked={TwoValue} onChange={handleSwitchChange2} />
            <span className="slider"></span>
          </label>
          {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
        </div>
      </div>
      {TwoValue ? (
        <select id="dropdown2" name="dropdown2" value={formState.dropdown2} onChange={handleChange} className="form-select">
          <option value="" disabled>
            {t("PleaseSelect")}
          </option>

          {CompaniesKYC.map((obj) => {
            return <option value={obj.value}>{obj.CompName}</option>;
          })}
        </select>
      ) : null}
      <hr style={{ width: "100%" }} />
      <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
        <label htmlFor="dropdown5" className="form-label">
          {t("executive_or_insider")}
        </label>
        <div className="switch-container">
          <label className="switch">
            <input type="checkbox" checked={ThreeValue} onChange={handleSwitchChange3} />

            <span className="slider"></span>
          </label>
          {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
        </div>
      </div>
      {ThreeValue ? (
        <select id="dropdown3" name="dropdown3" value={formState.dropdown3} onChange={handleChange} className="form-select">
          <option value="" disabled>
            {t("PleaseSelect")}
          </option>

          {CompaniesKYC.map((obj) => {
            return <option value={obj.value}>{obj.CompName}</option>;
          })}
        </select>
      ) : null}

      {/* <hr style={{ width: '100%' }} />
            <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
                <label htmlFor="dropdown5" className="form-label">
                    Do you have any 1st or 2nd degree relatives in SIFS?
                </label>
                <div className="switch-container">
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={FoureValue}
                            onChange={handleSwitchChange4}
                        />
                        <span className="slider"></span>
                    </label>
                    
                </div>

            </div> */}
    </div>
  );
};

export default FatcaCRSDeclaration6;
